module.exports = __webpack_public_path__ + "img/nepomucen_galeria.fc38a419.jpg";